<template>
  <div class="sidenav">
    <router-link class="success" :to="{name: 'login'}">LOGIN</router-link>
    <router-link class="info" :to="{name: 'my_rents'}">MINHAS LOCAÇÕES</router-link>
    <template v-if="user">
      <hr>
      <div class="text-center logged-user">{{ user.name }}</div>
      <a @click="logout()"><i class="fa fa-fw fa-sign-out"></i> SAIR</a>
    </template>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default{
    name: 'PartialDrawerNavigation',
    data () {
      return {}
    },
    computed: {
      ...mapState({
        user: state => state.user
      })
    },
    mounted () {},
    methods: {
      logout () {
        this.handleLogout()
        this.$emit('close-drawer')
      },
      ...mapActions([])
    }
  }
</script>



// WEBPACK FOOTER //
// PartialDrawerNavigation.vue?628dc0b2